/** Reads the `errorCode` extension the API puts on every ProblemDetails response (see ApiControllerBase.Problem). */
export function extractErrorCode(err: any): string | null {
  const errorObj = err?.error;
  if (errorObj && typeof errorObj === 'object') {
    const code = errorObj.errorCode ?? errorObj.ErrorCode;
    if (typeof code === 'string' && code.trim().length > 0) {
      return code.trim();
    }
  }
  return null;
}

export function extractErrorMessage(err: any, fallback = 'Operation failed. Please try again.'): string {
  if (!err) return fallback;

  const errorObj = err.error;

  // 1. Plain string error response
  if (typeof errorObj === 'string' && errorObj.trim().length > 0) {
    return errorObj.trim();
  }

  if (errorObj && typeof errorObj === 'object') {
    // 2. Check detail / Detail (ProblemDetails)
    if (typeof errorObj.detail === 'string' && errorObj.detail.trim().length > 0) {
      return errorObj.detail.trim();
    }
    if (typeof errorObj.Detail === 'string' && errorObj.Detail.trim().length > 0) {
      return errorObj.Detail.trim();
    }

    // 3. Check message / Message
    if (typeof errorObj.message === 'string' && errorObj.message.trim().length > 0) {
      return errorObj.message.trim();
    }
    if (typeof errorObj.Message === 'string' && errorObj.Message.trim().length > 0) {
      return errorObj.Message.trim();
    }

    // 4. Check validation errors dictionary / array
    const errorsProp = errorObj.errors || errorObj.Errors;
    if (errorsProp) {
      if (Array.isArray(errorsProp)) {
        const msgs = errorsProp
          .map((e: any) => (typeof e === 'string' ? e : e?.message || e?.Message || JSON.stringify(e)))
          .filter(Boolean);
        if (msgs.length > 0) return msgs.join(' ');
      } else if (typeof errorsProp === 'object') {
        const msgs: string[] = [];
        for (const key of Object.keys(errorsProp)) {
          const val = errorsProp[key];
          if (Array.isArray(val)) {
            msgs.push(...val.map(v => String(v)));
          } else if (typeof val === 'string') {
            msgs.push(val);
          }
        }
        if (msgs.length > 0) return msgs.join(' ');
      }
    }

    // 5. Check title / Title (if not generic validation title)
    if (
      typeof errorObj.title === 'string' &&
      errorObj.title.trim().length > 0 &&
      errorObj.title.trim() !== 'One or more validation errors occurred.'
    ) {
      return errorObj.title.trim();
    }
    if (
      typeof errorObj.Title === 'string' &&
      errorObj.Title.trim().length > 0 &&
      errorObj.Title.trim() !== 'One or more validation errors occurred.'
    ) {
      return errorObj.Title.trim();
    }
  }

  // 6. Check top-level err.message
  if (typeof err.message === 'string' && err.message.trim().length > 0) {
    return err.message.trim();
  }

  return fallback;
}
